/**
 * MS Cart Upsell Popup + Toast
 * v1 — 2026-05-03
 */
(function() {
  'use strict';

  let popup, backdrop, toast;
  let toastTimer;

  function init() {
    const drawer = document.querySelector('cart-drawer-component .cart-drawer__inner');
    if (!drawer) return false;

    document.querySelector('.ms-upsell-popup')?.remove();
    document.querySelector('.ms-upsell-popup-backdrop')?.remove();
    document.querySelector('.ms-cart-toast')?.remove();

    toast = document.createElement('div');
    toast.className = 'ms-cart-toast';
    toast.innerHTML = `
      <svg class="ms-cart-toast__check" viewBox="0 0 14 14" fill="none">
        <path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="ms-cart-toast__text">Dodano do koszyka</span>
    `;
    document.body.appendChild(toast);

    backdrop = document.createElement('div');
    backdrop.className = 'ms-upsell-popup-backdrop';
    drawer.appendChild(backdrop);

    popup = document.createElement('div');
    popup.className = 'ms-upsell-popup';
    popup.innerHTML = `
      <div class="ms-upsell-popup__header">
        <img class="ms-upsell-popup__img" src="" alt="">
        <div class="ms-upsell-popup__info">
          <p class="ms-upsell-popup__title"></p>
          <div class="ms-upsell-popup__price"></div>
        </div>
        <button class="ms-upsell-popup__close" aria-label="Zamknij">
          <svg viewBox="0 0 14 14" fill="none">
            <path d="M12 2L2 12M12 12L2 2" stroke="currentColor"
                  stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <p class="ms-upsell-popup__label">Wybierz rozmiar</p>
      <div class="ms-upsell-popup__sizes"></div>
    `;
    drawer.appendChild(popup);

    backdrop.addEventListener('click', closePopup);
    popup.querySelector('.ms-upsell-popup__close').addEventListener('click', closePopup);

    bindUpsellButtons();

    const observer = new MutationObserver(() => bindUpsellButtons());
    const itemsContainer = document.querySelector('.cart-drawer__items');
    if (itemsContainer) {
      observer.observe(itemsContainer, { childList: true, subtree: true });
    }
    return true;
  }

  function showToast(msg) {
    if (!toast) return;
    toast.querySelector('.ms-cart-toast__text').textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
  }

  function closePopup() {
    popup?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
  }

  function openPopup(productData) {
    popup.querySelector('.ms-upsell-popup__img').src = productData.img;
    popup.querySelector('.ms-upsell-popup__img').alt = productData.title;
    popup.querySelector('.ms-upsell-popup__title').textContent = productData.title;
    popup.querySelector('.ms-upsell-popup__price').innerHTML = productData.priceHTML;

    const sizesWrap = popup.querySelector('.ms-upsell-popup__sizes');
    sizesWrap.innerHTML = '';
    productData.sizes.forEach(s => {
      const btn = document.createElement('button');
      btn.className = 'ms-upsell-popup__size';
      btn.textContent = s.label;
      btn.dataset.variantId = s.variantId;
      btn.disabled = s.disabled;
      btn.addEventListener('click', () =>
        addVariantToCart(btn, s.variantId, productData.title, s.label)
      );
      sizesWrap.appendChild(btn);
    });

    popup.classList.add('is-open');
    backdrop.classList.add('is-open');
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartItems = doc.querySelector('cart-items-component');
      const oldCartItems = document.querySelector('cart-drawer-component cart-items-component');
      if (newCartItems && oldCartItems) {
        oldCartItems.innerHTML = newCartItems.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch(e) {
      console.error('[MS] Cart refresh failed:', e);
    }
  }

  async function addVariantToCart(btn, variantId, productTitle, sizeLabel) {
    btn.classList.add('is-loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add failed');

      await refreshCartDrawer();
      closePopup();
      showToast(`\u2713 Dodano: ${productTitle} \u00b7 ${sizeLabel}`);
    } catch(e) {
      btn.classList.remove('is-loading');
      showToast('B\u0142\u0105d \u2014 spr\u00f3buj ponownie');
      console.error('[MS] Add to cart error:', e);
    }
  }

  async function addSingleVariant(variantId, productTitle) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add failed');

      await refreshCartDrawer();
      showToast(`\u2713 Dodano: ${productTitle}`);
    } catch(e) {
      showToast('B\u0142\u0105d \u2014 spr\u00f3buj ponownie');
      console.error('[MS] Add to cart error:', e);
    }
  }

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' z\u0142';
  }

  function bindUpsellButtons() {
    document.querySelectorAll('.ms-upsell__item').forEach(item => {
      const btn = item.querySelector('.ms-upsell__item-btn');
      if (!btn || btn.dataset.msBound) return;
      btn.dataset.msBound = '1';

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const handle = btn.dataset.productHandle;
        const sizesEl = item.querySelector('.ms-upsell__sizes');
        const sizes = Array.from(sizesEl?.querySelectorAll('.ms-upsell__size-btn') || [])
          .map(b => ({
            label: b.textContent.trim(),
            variantId: b.dataset.variantId,
            disabled: b.hasAttribute('disabled'),
          }));

        if (sizes.length === 0) {
          try {
            const p = await (await fetch(`/products/${handle}.js`)).json();
            if (p.variants.length === 1) {
              addSingleVariant(p.variants[0].id, p.title);
            } else {
              const popupData = {
                img: item.querySelector('img')?.src || p.featured_image,
                title: p.title,
                priceHTML: `<span>${formatPrice(p.price)}</span>${
                  p.compare_at_price > p.price
                    ? ` <s>${formatPrice(p.compare_at_price)}</s>`
                    : ''
                }`,
                sizes: p.variants.map(v => ({
                  label: v.options[v.options.length - 1] || v.title,
                  variantId: v.id,
                  disabled: !v.available,
                })),
              };
              openPopup(popupData);
            }
          } catch(err) {
            console.error('[MS] Product fetch failed:', err);
            window.location.href = `/products/${handle}`;
          }
          return;
        }

        if (sizes.length === 1) {
          const variant = sizes[0];
          const title = item.querySelector('.ms-upsell__item-name')?.textContent?.trim()
                     || handle;
          if (!variant.disabled) {
            addSingleVariant(variant.variantId, title);
          }
          return;
        }

        const title = item.querySelector('.ms-upsell__item-name')?.textContent?.trim()
                   || handle;
        const priceHTML = item.querySelector('.ms-upsell__item-price')?.innerHTML || '';
        const img = item.querySelector('img')?.src || '';
        openPopup({ img, title, priceHTML, sizes });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-testid="cart-drawer-trigger"]')) {
      setTimeout(init, 300);
    }
  });
})();
